// removed by extract-text-webpack-plugin
module.exports = {"light":"src-components-project----themes-module---light---1myas","dark":"src-components-project----themes-module---dark---3D4iZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/project/themes.module.css
// module id = ./src/components/project/themes.module.css
// module chunks = 102538987983895